import { Typography, Button } from '@atoms';
import ErrorIcon from "@assets/icons/404.svg";
import { Container} from './error.styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Wrapper } from "../Login/login.styles";

function Error() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Container>
        <img src={ErrorIcon} alt='404'/>
        <Typography as='h3' style={{ textAlign: "center" }}>{t("notFound")}</Typography>

        <Button
          onClick={() => navigate("/")}
          style={{marginTop: '-8px'}}
        >
          {t("gtmain")}
        </Button>
      </Container>
    </Wrapper>
  );
};

export default Error;
